// Utility for AddonTable column visibility and grid-template-columns
import { AddonsTypes } from '@/features/Addons/types';

export const COLUMN_WIDTHS: Record<string, string> = {
  SELECT: '3rem',
  DATE: 'minmax(9rem, 0.3fr)',
  STATUS: 'minmax(14rem, 0.4fr)',
  PROVIDER: 'minmax(14rem, 0.4fr)',
  IMPORTED_BY: 'minmax(16rem, 0.5fr)',
  FROM: 'minmax(6rem, 0.8fr)',
  SUBJECT: 'minmax(6rem, 1.2fr)',
  TYPE: 'minmax(9rem, 0.3fr)',
  DOWNLOAD: '5rem',
};

export type AddonColumnKey = keyof typeof COLUMN_WIDTHS;

export const getVisibleColumns = (settings: AddonsTypes.Settings): AddonColumnKey[] =>
  [
    settings.columns.SELECT && 'SELECT',
    settings.columns.DATE && 'DATE',
    settings.columns.STATUS && 'STATUS',
    settings.columns.PROVIDER && 'PROVIDER',
    settings.columns.IMPORTED_BY && 'IMPORTED_BY',
    settings.columns.FROM && 'FROM',
    settings.columns.SUBJECT && 'SUBJECT',
    settings.columns.TYPE && 'TYPE',
    settings.columns.DOWNLOAD && 'DOWNLOAD',
  ].filter(Boolean) as AddonColumnKey[];

export const getAddonTableGridTemplateColumns = (settings: AddonsTypes.Settings): string =>
  getVisibleColumns(settings)
    .map((col) => COLUMN_WIDTHS[col])
    .join(' ');
